/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideDefaultConfig } from '@lm-nx-frontend/lm-inf-core';
import { defaultPaginationConfig } from './config';
import { PaginationComponent } from './pagination.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [provideDefaultConfig(defaultPaginationConfig)],
  declarations: [PaginationComponent],
  exports: [PaginationComponent],
})
export class PaginationModule {}
